export default function isArray(array: unknown): boolean {
  return Array.isArray(array);
}
